import NestedFilter from './NestedFilter';

/**
 * Saved search filter (DB table server.search_filter)
 */
class SavedSearchFilter {
	constructor(input) {
		this.id = ko.observable();
		this.date_inserted = ko.observable();
		this.username = ko.observable();

		this.context = ko.observable();
		this.name = ko.observable();
		this.filter = new NestedFilter();
		// this.permanent_filters = new NestedFilter();

		this.fields = ko.observableArray();
		this.tags = ko.observableArray([]);

		if (input)
			this.set(input);
	}

	add_filter(join_type) {
		return this.filter.add_filter(join_type);
	}

	remove_filter(filter) {
		this.filter.remove_filter(filter);
	}

	get() {
		return {
			id: this.id(),
			date_inserted: this.date_inserted(),
			username: this.username(),
			context: this.context(),
			name: this.name(),
			// permanent_filters: this.permanent_filters.get(),
			filters: this.filter.get(),
			fields: this.fields(),
			tags: this.tags()
		};
	}

	set(input) {
		input = ko.mapping.toJS(input ?? {});
		
		this.id(input.id);
		this.date_inserted(input.date_inserted);
		this.context(input.context);
		this.name(input.name);
		this.username(input.username);
		// this.permanent_filters.set(input.permanent_filters);
		this.filter.set(input.filters);
		this.fields(input.fields);
		this.tags(input.tags);
	}

	async fetch() {
		const data = await Grape.fetches.getJSON('/api/record',
			{
				schema: 'server',
				table: 'v_search_filters',
				returning: '*',
				filter: [{ field: 'name', operator: '=', value: this.name() }]
			});
		return data;
	}

	async save() {
		const data = await Grape.fetches.postJSON('/api/record',
			{
				schema: 'server',
				table: 'v_search_filters',
				returning: '*',
				values: this.get()
			});
		
		return data;
	}

	async delete() {
		const data = await Grape.fetches.deleteJSON('/api/record',
			{
				schema: 'server',
				table: 'v_search_filters',
				returning: '*',
				filter: [{ field: 'name', operator: '=', value: this.name() }]
			});

		return data;
	}
}

export default SavedSearchFilter;
